import Faq from "../components/Faq";
import Features from "../components/Features";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import SafetyBanner from "../components/SafetyBanner";
import SlotDemo from "../components/SlotDemo";
import Stats from "../components/Stats";

const HomePage = () => {
  return (
    <>
      <Hero />
      <SlotDemo />
      <Features />
      <Stats />
      <SafetyBanner />
      <Faq />
      <Footer />
    </>
  );
};

export default HomePage;